import styled from 'styled-components';
import { color, container, screen, spacing } from '../../../theme';

export const StyledHow = styled.section`
  background-color: ${color('white')};
  padding-top: ${spacing('xl3')};
  padding-bottom: ${spacing('xl3')};

  @media (min-width: ${screen('lg')}) {
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl4')};
  }
`;

export const StyledContainer = styled.div`
  margin: auto;
  max-width: calc(${container('xl')} + ${spacing('md')} * 2);
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  text-align: center;
`;

export const StyledVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  margin-top: ${spacing('xl3')};
  margin-bottom: ${spacing('xl4')};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
